
import { state } from "@/store/modules/pedigree/state";
import mutations from "@/store/modules/pedigree/mutations"
import actions from "@/store/modules/pedigree/actions"
import getters from "@/store/modules/pedigree/getters"

/** @returns { import('vuex').Module } */
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
}